function Home() {
  return (
    <div className="homestyle">
      <h1>QuizzAPP.</h1>
      <h2>Testez vos connaissances en React.js !</h2>
      <button><a href="/#/quiz">Commencer le Quiz</a></button>
    </div>
  );
}

export default Home;
